export default __webpack_public_path__ + "static/media/GitHub.1450d64e.png";